import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Delete } from '@material-ui/icons';
import { parseISO, format } from 'date-fns';
import moment from 'moment';

import { UnidataTable } from '~/components';
import { DialogConfirmation } from '~/componentsLocal';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  MOTORISTA_ABASTECIMENTO,
} from '~/constants/modules';
import { t, can, canURL, number } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  dataInRequest,
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/operacaoLubrificacao/actions';

import MyForm from './form';
import FormDeletar from './formDeletar';

function OperacaoLubrificacaoList() {
  const redux = useSelector((state) => state.operacaoLubrificacao);

  const buttons = [];

  const deleteRef = useRef(null);

  const temTarefaOficina = canURL().lubrificacao_oficina;

  const totalizador = useMemo(
    () => [
      { label: 0, value: 'Não Possui' },
      { label: 1, value: t('s.operacao.abastecimento.horimetro') },
      { label: 2, value: t('s.operacao.abastecimento.hodometro') },
    ],
    []
  );

  const statusSimNao = useMemo(
    () => [
      { label: 1, value: t('s.geral.opcoes.sim') },
      { label: 0, value: t('s.geral.opcoes.nao') },
    ],
    []
  );

  const statusSimNaoStr = useMemo(
    () => [
      { label: 'S', value: t('s.geral.opcoes.sim') },
      { label: 'N', value: t('s.geral.opcoes.nao') },
    ],
    []
  );

  const operacaoLubrificacao = useSelector(
    (state) => state.operacaoLubrificacao
  );

  const { exibeoslubrificacao, internounidatausuario } = useSelector(
    (state) => state.user.configs
  );

  const initialDate = useMemo(() =>
    moment().set({ hour: 0, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm')
  );

  const finalDate = useMemo(() =>
    moment()
      .set({ hour: 23, minute: 59, second: 59 })
      .format('YYYY-MM-DDTHH:mm')
  );

  const header = useMemo(() => {
    const data = [
      // {
      //   id: 'datahorainicialmovimentacao',
      //   label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
      //   format: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      //   filter: {
      //     type: 'initialdatetime',
      //     defaultValue: initialDate,
      //   },
      // },
      // {
      //   id: 'datahorafinalmovimentacao',
      //   label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
      //   format: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
      //   filter: {
      //     type: 'finaldatetime',
      //     defaultValue: finalDate,
      //   },
      // },
      {
        id: 'datahorainicialmovimentacao',
        label: t('s.operacao.abastecimento.datahorainicialmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 00:00:00'),
        },
      },
      {
        id: 'datahorafinalmovimentacao',
        label: t('s.operacao.abastecimento.datahorafinalmovimentacao'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'nomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idbico',
        label: t('s.operacao.abastecimento.idbico'),
        filter: {
          type: 'number',
        },
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.abastecimento.nomeproduto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idveiculo',
        label: t('s.operacao.abastecimento.idveiculo'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'descricaocompartimentostr',
        label: t('s.operacao.lubrificacao.idcompartimento'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'trocalubmovimentacaolubrificacao',
        label: t('s.operacao.lubrificacao.trocalubmovimentacaolubrificacao'),
        converter: statusSimNao,
        filter: {
          type: 'select',
          options: statusSimNao,
        },
      },
      {
        id: 'totalizadormovimentacaoabastecimento',
        label: t(
          's.operacao.abastecimento.totalizadormovimentacaoabastecimento'
        ),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.abastecimento.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
    ];

    if (can(CENTRO_CUSTO_ABASTECIMENTO)) {
      data.splice(5, 0, {
        id: 'idcentrocusto',
        label: t('s.operacao.abastecimento.idcentrocusto'),
        filter: {
          type: 'text',
        },
      });
    }

    if (temTarefaOficina) {
      data.splice(8, 0, {
        id: 'lubrificacaooficinaatendimento',
        label: t('s.geral.oficina'),
        formatted: (value) =>
          statusSimNaoStr.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: statusSimNaoStr },
      });
    }

    if (exibeoslubrificacao !== 0) {
      data.splice(9, 0, {
        id: 'numeroosmovimentacaolubrificacao',
        label: t('s.operacao.lubrificacao.numeroosmovimentacaolubrificacao'),
        filter: {
          type: 'text',
        },
      });
    }

    return data;
  }, [initialDate, finalDate, totalizador, exibeoslubrificacao]);

  if (internounidatausuario === 'S') {
    buttons.push({
      title: t('s.geral.botaoexcluir'),
      action: (value) => deleteRef.current.handleOpen(value),
      icon: <Delete />,
    });
  }

  const fieldlist = [
    'datahorainicialmovimentacao',
    'datahorafinalmovimentacao',
    'codigonomeposto',
    'idbico',
    'nomeproduto',
    'volumemovimentacao',
    'idveiculo',
    'totalizadormovimentacaoabastecimento',
    'encerranteinicialmovimentacao',
    'encerrantefinalmovimentacao',
    'codigousuario',
    'idcompartimento',
    'trocalubmovimentacaolubrificacao',
  ];

  const substituirHeader = {
    datahorainicialmovimentacao: t(
      's.operacao.abastecimento.datahorainicialmovimentacao'
    ),
    datahorafinalmovimentacao: t(
      's.operacao.abastecimento.datahorafinalmovimentacao'
    ),
    codigonomeposto: t('s.operacao.abastecimento.nomeposto'),
    idbico: t('s.operacao.abastecimento.idbico'),
    nomeproduto: t('s.operacao.abastecimento.nomeproduto'),
    volumemovimentacao: t('s.operacao.abastecimento.volumemovimentacao'),
    idveiculo: t('s.operacao.abastecimento.idveiculo'),
    totalizadormovimentacaoabastecimento: t(
      's.operacao.abastecimento.totalizadormovimentacaoabastecimento'
    ),
    encerranteinicialmovimentacao: t(
      's.operacao.abastecimento.encerranteinicialmovimentacao'
    ),
    encerrantefinalmovimentacao: t(
      's.operacao.abastecimento.encerrantefinalmovimentacao'
    ),
    codigousuario: t('s.operacao.abastecimento.codigousuario'),
    idcompartimento: t('s.operacao.lubrificacao.idcompartimento'),
    trocalubmovimentacaolubrificacao: t(
      's.operacao.lubrificacao.trocalubmovimentacaolubrificacao'
    ),
  };

  if (can(CENTRO_CUSTO_ABASTECIMENTO)) {
    fieldlist.push('idcentrocusto');
    substituirHeader.idcentrocusto = t(
      's.operacao.abastecimento.idcentrocusto'
    );
  }

  if (can(MOTORISTA_ABASTECIMENTO)) {
    fieldlist.push('idmotorista');
    substituirHeader.idmotorista = t('s.operacao.abastecimento.idmotorista');
  }

  if (temTarefaOficina) {
    fieldlist.push('lubrificacaooficinaatendimento');
    substituirHeader.lubrificacaooficinaatendimento = t('s.geral.oficina');
  }

  return (
    <>
      <UnidataTable
        fixed
        actions={buttons}
        redux={operacaoLubrificacao}
        header={header}
        read={recordFiltering}
        find={findData}
        delete={internounidatausuario.toLowerCase() !== 's'}
        remove={deleteData}
        form={MyForm}
        formAux={FormDeletar}
        keys={['idmovimentacao', 'idposto']}
        detach="nomeposto"
        pdf
        excel
        onExport={(formato) =>
          handleExportGeneric({
            endpoint: 'movimentacoeslubrificacoes',
            formato,
            fields: fieldlist,
            headers: substituirHeader,
            redux,
            ordination: redux.params.ordination,
            orderfield: redux.params.orderfield,
            title: 'Relatorio de Lubrificação',
            substituirValores: {
              trocalubmovimentacaolubrificacao: {
                '1': t('s.geral.opcoes.sim'),
                '0': t('s.geral.opcoes.nao'),
              },
              lubrificacaooficinaatendimento: {
                S: t('s.geral.opcoes.sim'),
                N: t('s.geral.opcoes.nao'),
              },
            },
          })
        }
      />

      {/* <Tabela
        noDelete={internounidatausuario === 'S'}
        read={dataInRequest}
        remove={deleteData}
        state={operacaoLubrificacao}
        header={header}
        headerMobile="nomeposto"
        unique={['idmovimentacao', 'idposto']}
        form={MyForm}
        buttons={buttons}
        findItem={findData}
        recordFilter={recordFiltering}
      /> */}

      <DialogConfirmation
        ref={deleteRef}
        keys={['idmovimentacao', 'idposto']}
        title="Justificativa para exclusão de registro"
        redux={deleteData}
        query={operacaoLubrificacao.params}
      />
    </>
  );
}

export default OperacaoLubrificacaoList;
